/**
 * @returns {RegExp}
 */
function phone () {
  return /^([0-9()/+-]*)$/
}

module.exports = { phone }
